import { Controller } from "@hotwired/stimulus"

// Builder dashboard: on-demand billing advisor (A5) with polling.
export default class extends Controller {
  static targets = ["advice", "adviceBtn"]
  static values = { adviceUrl: String, adviceStatusUrl: String }

  connect() {
    const msg = sessionStorage.getItem("builder-finance.flash")
    if (msg) {
      sessionStorage.removeItem("builder-finance.flash")
      this._showToast(msg)
    }
  }

  disconnect() { clearInterval(this._poll) }

  async refreshAdvice() {
    this.adviceBtnTarget.disabled = true
    this.adviceBtnTarget.innerHTML = "Thinking…"
    try {
      const resp = await fetch(this.adviceUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
      const data = await resp.json()
      if (!resp.ok) throw new Error(data.error || "Could not ask the advisor")
      this._pollAdvice(data.run_id)
    } catch (err) {
      this._showToast(err.message, "alert")
      this._resetBtn()
    }
  }

  _pollAdvice(runId) {
    let ticks = 0
    this._poll = setInterval(async () => {
      if (++ticks > 60) { clearInterval(this._poll); this._resetBtn(); return }
      const resp = await fetch(`${this.adviceStatusUrlValue}?run_id=${runId}`, { headers: { "Accept": "application/json" } })
      const data = await resp.json()
      if (data.status === "done") {
        clearInterval(this._poll)
        const r = data.result || {}
        this.adviceTarget.textContent = `${r.headline || ""} — ${r.advice || ""}`
        this.adviceTarget.classList.remove("hidden")
        this._resetBtn()
      } else if (data.status === "failed") {
        clearInterval(this._poll)
        this._showToast(data.error || "The advisor didn't answer — try again.", "alert")
        this._resetBtn()
      }
    }, 2500)
  }

  _resetBtn() {
    this.adviceBtnTarget.disabled = false
    this.adviceBtnTarget.innerHTML = "✨ Ask the billing advisor"
  }

  _showToast(message, type = "notice") {
    const div = document.createElement("div")
    div.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    div.setAttribute("data-controller", "flash")
    div.setAttribute("data-flash-dismiss-after-value", "5000")
    div.textContent = message
    document.body.prepend(div)
  }
}
